<template lang="pug">
.container-fluid
  vm-row(vm-w="12")
    vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
      .menu-bar
        .menu-bar-item(v-for="(item, index) in menuBarItems" :key="index" @click="select(item.index)" :class="selectedMenu === item.index ? 'selected-menu' : ''")
          vm-icon(:icon="item.icon" size="1.5rem" color="#000")
          span(:class="selectedMenu === item.index ? 'text-menu-selected' : '' ") {{ $t(item.text) }}
  transition(name="menu-fade" mode="out-in")
    view-purchase-orders(v-if="selectedMenu === 1")
    view-purchase-orders-products(v-else-if="selectedMenu === 2")
</template>

<script>

const ViewPurchaseOrders = () => import('@/components/purchase_orders/ViewPurchaseOrders.vue')
const ViewPurchaseOrdersProducts = () => import('@/components/purchase_orders/ViewPurchaseOrdersProducts.vue')

export default {
  name: 'PurchaseOrders',
  components: {
    ViewPurchaseOrders,
    ViewPurchaseOrdersProducts
  },
  data: () => ({
    selectedMenu: 1,
    menuBarItems: [
      {
        index: 1,
        icon: 'file-text-outline',
        text: 'strings.purchase_orders'
      },
      {
        index: 2,
        icon: 'list-outline',
        text: 'strings.products'
      }
    ]
  }),
  methods: {
    select (payload) {
      this.selectedMenu = payload
    }
  }
}
</script>

<style lang="scss">

  .menu-bar {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    margin-bottom: 2rem;

    .menu-bar-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
    }
  }
  .text-menu-selected {
    color: rgba(var(--primary), 1);
  }
  .selected-menu {
    -webkit-box-shadow: 0 8px 6px -6px rgba(var(--primary), 1);
    -moz-box-shadow: 0 8px 6px -6px rgba(var(--primary), 1);
    box-shadow: 0 8px 6px -6px rgba(var(--primary), 1);
  }
  .menu-fade-enter-active, .menu-fade-leave-active {
    transition: opacity .3s ease;
  }

</style>
